import React from 'react';
import FooterNav from '@xo-union/tk-component-footer-nav/remote';

const analyticsProps = {product: "fashion"};

export default function Footer({}) {
  return (
    <div>
      <FooterNav metadata={{applicationName: 'fashion'}} analyticsProps={analyticsProps} tag="latest" ssi/>
    </div>
  );
}
